import domain from './domain';

// Reset task addons
export const resetTaskCategoryAddons = domain.createEvent('resetTaskCategoryAddons');
